import React from 'react';
import { Option } from '../models/option';
import { MeasurementSystem } from '../enums/measurement-system.enum';
import { parseEngineVariables } from '../utils/engine-helper';
import { StepValues } from '../models/step-values';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { SlimRadioOption } from './SlimRadioOption';

interface Props {
  isSelected: boolean | undefined;
  option: Option;
  onClick: (event: any) => void;
  dataKey: string | number | undefined;
  activeMeasurement: any;
  stepValues: StepValues;
  productHandle: ProductHandle;
}

export const RadioOption: React.FC<Props> = ({ option, stepValues, productHandle, activeMeasurement, dataKey, isSelected, onClick }) => {
  const optionText = option.text
    ? parseEngineVariables(option.text, stepValues, productHandle)
    : activeMeasurement === MeasurementSystem.Imperial
    ? option.imperialText
    : option.metricText;

  return <SlimRadioOption dataKey={dataKey} isSelected={isSelected} onClick={(event) => onClick(event)} text={optionText} iconName={option.iconName} />;
};

export default RadioOption;
